<template>
	<div ref="container" style="height:100%;position:relative;overflow:hidden;"></div>
</template>

<script>
import ScrollerWidget from '@/widgets/ScrollerWidget';

const mockSocket = { subscribe() { return 0; }, unsubscribe() {} };

let msgIdCounter = 0;

const USERNAMES = ['StreamerFan99', 'TechWizard', 'CosmicViewer', 'NightOwl42', 'PixelKnight', 'GamerPro77', 'CoolCat88', 'StreamLurker', 'HappyDonor', 'LoyalViewer'];

export default {
	name: 'ScrollerWidgetPreview',
	props: {
		settings: { type: Object, default: () => ({}) },
	},
	data() {
		return {
			services: [],
		};
	},
	watch: {
		settings: {
			deep: true,
			handler(s) { this._applySettings(s); },
		},
	},
	mounted() {
		this._initWidget();
		this.$api.get('channels')
			.then(channels => {
				const seen = new Set();
				this.services = channels.filter(c => {
					if(!c.service_icon_url || seen.has(c.service_id)) return false;
					seen.add(c.service_id);
					return true;
				});
				this._populateFakeAlerts();
			})
			.catch(() => {
				this._populateFakeAlerts();
			});
	},
	beforeDestroy() {
		this._destroyWidget();
	},
	methods: {
		async _initWidget() {
			let hash = 'preview';
			try {
				const user = await this.$api.get('userData');
				hash = user.widget_hash || 'preview';
			} catch(e) { /* ignore */ }
			if(!this.$refs.container) return;

			const self = this;
			const proxyApi = {
				get(path) {
					if(path.includes('/settings/')) return Promise.resolve({ ...(self.settings || {}) });
					if(path.includes('/alerts')) return Promise.resolve([]);
					return self.$api.get(path);
				},
				post() { return Promise.resolve(); },
			};

			this.widget = new ScrollerWidget({
				container: this.$refs.container,
				api: proxyApi,
				socket: mockSocket,
				hash,
			});

			await this.widget.init();

			// Strip html/body rules so they don't affect the settings page layout
			const baseCSSElem = document.getElementById('scBaseCSS');
			if(baseCSSElem) {
				baseCSSElem.textContent = baseCSSElem.textContent
					.replace(/(?:html|body)(?:\s*,\s*(?:html|body))?\s*\{[^}]*\}/g, '');
			}
		},
		_destroyWidget() {
			if(this.widget) {
				this.widget.destroy();
				this.widget = null;
				if(this.$refs.container) this.$refs.container.innerHTML = '';
			}
		},
		_applySettings(s) {
			if(!this.widget) return;
			this.widget.applySettings({ ...s });
		},
		_populateFakeAlerts() {
			if(!this.widget) return;
			const count = this.settings.itemCount || 10;
			for(let i = 0; i < count; i++) {
				const username = USERNAMES[i % USERNAMES.length];
				const amount = Math.round((1 + Math.random() * 299) * 100) / 100;

				let serviceId = null, serviceName = null, serviceIconUrl = null;
				if(this.services.length > 0) {
					const svc = this.services[i % this.services.length];
					serviceId    = svc.service_id;
					serviceName  = svc.service_name || svc.service_id;
					serviceIconUrl = svc.service_icon_url;
				}

				this.widget._pushAlert({
					id: `preview-${++msgIdCounter}`,
					serviceId,
					serviceName,
					serviceIconUrl,
					type: 'gift',
					giftType: 'donation',
					value: amount,
					currency: 'USD',
					sender: { displayName: username, avatar: null },
					spans: [],
				});
			}
			this.widget._rebuildTrack();
		},
	},
};
</script>
